import { render, staticRenderFns } from "./inedx.vue?vue&type=template&id=4ebb944a&"
import script from "./inedx.vue?vue&type=script&lang=ts&"
export * from "./inedx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports